import { CheckCircle } from '@mui/icons-material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useQueryClient } from '@tanstack/react-query';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { emitWarrantyInvoice } from 'lib/api/sgr';
import CustomButton from 'lib/designSystem/Button';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import { showAlert } from 'lib/functions/utils';
import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

type Props = {
  open: boolean;
  onClose: () => void;
  id: number;
};

const ConfirmInvoiceDialog: React.FC<Props> = ({ open, onClose, id }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { mutate, isPending } = emitWarrantyInvoice(dispatch);
  const [issuedDate, setIssuedDate] = useState<Dayjs | null>(dayjs());

  const handleConfirm = () => {
    mutate(
      {
        warrantyRequestIds: [id],
        manual: true,
        issuedDate: issuedDate?.toDate(),
      },
      {
        onSuccess: () => {
          onClose();
          showAlert(dispatch, 'success', 'Factura emitida correctamente');
          void queryClient.invalidateQueries({
            queryKey: ['sgrWarrantyRequestInvoicing', id],
          });
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        onClose={onClose}
        title="Confirmar Factura"
        icon={<CheckCircle color="primary" />}
        color="primary"
      />

      <DialogContent>
        <FormControl fullWidth margin="dense">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Fecha de Emisión"
              value={issuedDate}
              onChange={(date) => setIssuedDate(date)}
              slotProps={{ textField: { fullWidth: true, required: true } }}
            />
          </LocalizationProvider>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={handleConfirm}
          color="primary"
          loading={isPending}
          disabled={isPending}
        >
          Confirmar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmInvoiceDialog;
